import { Caption1, Spinner, makeStyles, tokens } from '@fluentui/react-components';
import { CheckmarkCircleRegular, ErrorCircleRegular, EditRegular } from '@fluentui/react-icons';

import { AUTOSAVE_STATUS, TAutosaveStatus } from '../../constants';

const useStyles = makeStyles({
  root: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalXS },
  saved: { color: tokens.colorNeutralForeground3 },
  failed: { color: tokens.colorStatusDangerForeground1 },
});

// Footer autosave indicator: Saved, Saving, Unsaved changes, Save failed.
export const AutosaveStatus = ({ status }: { status: TAutosaveStatus }) => {
  const classes = useStyles();

  if (status === AUTOSAVE_STATUS.SAVING) {
    return (
      <div className={classes.root}>
        <Spinner size="tiny" />
        <Caption1 className={classes.saved}>Saving</Caption1>
      </div>
    );
  }

  if (status === AUTOSAVE_STATUS.FAILED) {
    return (
      <div className={classes.root}>
        <ErrorCircleRegular className={classes.failed} />
        <Caption1 className={classes.failed}>Save failed</Caption1>
      </div>
    );
  }

  if (status === AUTOSAVE_STATUS.UNSAVED) {
    return (
      <div className={classes.root}>
        <EditRegular className={classes.saved} />
        <Caption1 className={classes.saved}>Unsaved changes</Caption1>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <CheckmarkCircleRegular className={classes.saved} />
      <Caption1 className={classes.saved}>Saved</Caption1>
    </div>
  );
};
